import { useState } from "react"

const useBool = init => {
  const [val, setVal] = useState(init)
  return [val, () => setVal(!val)]
}

export default useBool
